import { defineComponent as _defineComponent } from 'vue';
import ActivityPanel from "@/components/Panels/ActivityPanel.vue";
import PluginList from "@/components/Visualizations/PluginList.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'VisualizationPanel',
    setup(__props) {
        return { __sfc: true, ActivityPanel, PluginList };
    }
});
